import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getProject } from '../api/Projects'
import AFrameViewer from '../aframe/AFrameViewer'
import { Splash } from './Splash'
import { Permissions } from './Permissions'

function Viewer({ match }) {
    const stage = match.params.stage || 'prod'
    const qs = useLocation().search
    const query = useMemo(() => new URLSearchParams(qs), [qs])

    const projectId = useMemo(() => {
        debugger
        const idInPath = match.params.projectId
        const idInQueryString = query.get('id')

        if (idInPath === 'clip' && !!idInQueryString) {
            return idInQueryString
        }
        return idInPath
    }, [match, query])

    const [status, setStatus] = useState('loading')
    const [project, setProject] = useState()

    const delay = async () => {
        return new Promise((resolve, _) => {
            setTimeout(() => {
                resolve()
            }, 1500)
        })
    }

    useEffect(() => {
        setStatus('loading')
        getProject(projectId, stage)
            .then((project) => {
                if (project.title) {
                    document.title = project.title
                }
                setProject(project)
                setStatus('brand')

                return delay()
            })
            .then(() => {
                setStatus('loaded')
            })
            .catch((error) => {
                setStatus(error.message)
            })
    }, [projectId, stage])

    if (status === 'loading' || !project) {
        return <Splash variant="project" />
    }

    if (status === 'brand' && project) {
        return <Splash project={project} />
    }

    if (status === 'missing-permissions') {
        return <Permissions />
    }

    if (status !== 'loaded') {
        return <h6>{status}</h6>
    }

    return (
        <AFrameViewer
            project={project}
            onMissingPermissions={() => setStatus('missing-permissions')}
        />
    )
}

export default Viewer
